import { createSlice } from '@reduxjs/toolkit';
import { fetchByCategoryParam } from './categoryDataSlice';
import { removeSubAndSub } from '../../components/QuickFilters/Charts/Chart';

const chartFilterSlice = createSlice({
	name: 'chartFilters',
	initialState: {
		filtrationParameters: {
			cid: null,
			value: null
		},
		chartState: {
			availableChartList: [],
			selectedChart: null
		},
		zoomState: {
			isZoomed: false
		}
	},
	reducers: {
		updateFiltrationParameters: (state, action) => {
			const { cid, value } = action.payload;
			state.filtrationParameters.cid = cid;
			state.filtrationParameters.value = value;
		},
		resetChartFiltrationParameters: state => {
			state.filtrationParameters.cid = null;
			state.filtrationParameters.value = null;
		},
		updateZoomState: (state, action) => {
			state.zoomState.isZoomed = action.payload;
		},
		updateChartState: (state, action) => {
			state.chartState.selectedChart = action.payload;
		}
	},
	extraReducers: {
		[fetchByCategoryParam.fulfilled]: (_state, action) => {
			try {
				const { graphFilters } = action.payload;
				const graphFiltersSorted = graphFilters.map(gf => ({ ...gf })).sort((a, b) => a.order - b.order);
				const availableChartList = graphFiltersSorted.map(ch => removeSubAndSub(ch.gfHeading));
				const selectedChart = availableChartList[0];
				return {
					filtrationParameters: {
						cid: null,
						value: null
					},
					chartState: {
						availableChartList: availableChartList,
						selectedChart: selectedChart
					},
					zoomState: {
						isZoomed: null
					}
				};
			} catch (e) {
				console.error(e);
			}
		}
	}
});

export const { resetChartFiltrationParameters, updateChartState, updateZoomState } = chartFilterSlice.actions;
export default chartFilterSlice;
